import { useSelector } from "react-redux";
import { custom_auth } from "../../context";

/**
 * Returns the correct guest profile based on the authentication setup.
 * This hook is not responsible for populating the profile in the state,
 * it assumes that the state is already loaded.
 * @returns {Object|null} The guest profile.
 */
export const useGuestProfile = () => {
  const guestProfile = useSelector((state) => state.GuestProfile);
  const profile = custom_auth ? guestProfile?.extProfile ?? {} : guestProfile;
  return profile;
};
